import type { GeneralIconName } from '@shared/ui/icon';

/** Figma `Toast` 세트(Components, 39:1876)의 tone 축. 면은 모두 어두운 반전 면이고 종류는 아이콘으로 구분한다 */
export const TOAST_MESSAGE_TONES = ['neutral', 'success', 'danger'] as const;
export type ToastMessageTone = (typeof TOAST_MESSAGE_TONES)[number];

/** 앞 아이콘 이름 */
export const TOAST_MESSAGE_ICON_NAME: Record<ToastMessageTone, GeneralIconName> = {
  neutral: 'info',
  success: 'check-circle',
  danger: 'alert-circle',
};
